import React, { useEffect, useState } from "react";
import axiosInstance from "../../utils/axiosInstance";
import "./SpinAdmin.css";

const SpinAdmin = () => {
  const [options, setOptions] = useState([]);
  const [analytics, setAnalytics] = useState({});
  const [form, setForm] = useState({
    label: "",
    rewardType: "coin",
    coinAmount: 0,
    itemName: "",
    probability: 10,
    isActive: true,
  });

  const [editId, setEditId] = useState(null);

  useEffect(() => {
    fetchOptions();
    fetchAnalytics();
  }, []);

  const fetchOptions = async () => {
    try {
      const { data } = await axiosInstance.get("/admin/spin-option");
      setOptions(data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchAnalytics = async () => {
    try {
      const { data } = await axiosInstance.get("/admin/spin-analytics");
      setAnalytics(data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (editId) {
        await axiosInstance.put(`/admin/spin-option/${editId}`, form);
        setEditId(null);
      } else {
        await axiosInstance.post("/admin/spin-option", form);
      }
      setForm({
        label: "",
        rewardType: "coin",
        coinAmount: 0,
        itemName: "",
        probability: 10,
        isActive: true,
      });
      fetchOptions();
      fetchAnalytics();
    } catch (err) {
      console.error(err);
    }
  };

  const handleEdit = (option) => {
    setEditId(option._id);
    setForm({
      label: option.label,
      rewardType: option.rewardType,
      coinAmount: option.coinAmount,
      itemName: option.itemName,
      probability: option.probability,
      isActive: option.isActive,
    });
  };

  const handleDelete = async (id) => {
    try {
      await axiosInstance.delete(`/admin/spin-option/${id}`);
      fetchOptions();
      fetchAnalytics();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="spin-admin">
      <h1>Spin Option Management</h1>

      {/* Analytics */}
      <div className="analytics">
        <div className="card">
          <h3>Total Spins</h3>
          <p>{analytics.totalSpins || 0}</p>
        </div>
        <div className="card">
          <h3>Total Coins</h3>
          <p>{analytics.totalCoins || 0}</p>
        </div>
        <div className="card">
          <h3>Item Rewards</h3>
          <p>{analytics.items ? analytics.items.length : 0}</p>
        </div>
      </div>

      {/* Create/Edit Form */}
      <form className="spin-form" onSubmit={handleSubmit}>
        <h2>{editId ? "Edit Spin Option" : "Create Spin Option"}</h2>

        <div className="form-row">
          <div className="form-group">
            <label>Label</label>
            <input
              name="label"
              value={form.label}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Reward Type</label>
            <select
              name="rewardType"
              value={form.rewardType}
              onChange={handleChange}
            >
              <option value="coin">Coin</option>
              <option value="item">Item</option>
              <option value="none">None</option>
            </select>
          </div>
        </div>

        {form.rewardType === "coin" && (
          <div className="form-row">
            <div className="form-group">
              <label>Coin Amount</label>
              <input
                name="coinAmount"
                type="number"
                value={form.coinAmount}
                onChange={handleChange}
              />
            </div>
          </div>
        )}

        {form.rewardType === "item" && (
          <div className="form-row">
            <div className="form-group">
              <label>Item Name</label>
              <input
                name="itemName"
                value={form.itemName}
                onChange={handleChange}
              />
            </div>
          </div>
        )}

        <div className="form-row">
          <div className="form-group">
            <label>Probability</label>
            <input
              name="probability"
              type="number"
              value={form.probability}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group checkbox">
            <label>Active</label>
            <input
              name="isActive"
              type="checkbox"
              checked={form.isActive}
              onChange={handleChange}
            />
          </div>
        </div>

        <button className="btn" type="submit">
          {editId ? "Update" : "Create"}
        </button>
      </form>

      {/* List */}
      <div className="option-list">
        <h2>All Spin Options</h2>
        {options.map((opt) => (
          <div className="option-item" key={opt._id}>
            <div>
              <h3>{opt.label}</h3>
              <p>
                <b>Type:</b> {opt.rewardType} |{" "}
                <b>Prob:</b> {opt.probability} |{" "}
                <b>Active:</b> {opt.isActive ? "Yes" : "No"}
              </p>
              {opt.rewardType === "coin" && (
                <p>
                  <b>Coins:</b> {opt.coinAmount}
                </p>
              )}
              {opt.rewardType === "item" && (
                <p>
                  <b>Item:</b> {opt.itemName}
                </p>
              )}
            </div>

            <div className="actions">
              <button className="btn edit" onClick={() => handleEdit(opt)}>
                Edit
              </button>
              <button className="btn delete" onClick={() => handleDelete(opt._id)}>
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SpinAdmin;
